<template>
  <q-page padding>
    <PageHeader
      title="Carga de usuários por planilha"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="usuario" label="Usuário" />
      <q-tab name="associar" label="Associar Perfil" />
      <q-tab name="desassociar" label="Desassociar Perfil" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <!-- ===== TAB USUÁRIO ===== -->
      <q-tab-panel name="usuario">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Usuário
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>

        <infot-upload
          :activeSlide="activeSlide"
          :infos="infos"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/controle-funcao/usuarios_r3.xlsx"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">Enviar planilha de usuários</h6>
          </div>

          <div class="upload-content">
            <div
              class="upload-area"
              :class="{ 'file-selected': file, 'drag-over': isDragOver }"
              @dragover.prevent="onDragOver"
              @dragleave.prevent="onDragLeave"
              @drop.prevent="onDrop"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!file">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />
                    {{ file.name }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="file ? 'positive' : 'primary'"
                      :icon="file ? 'check_circle' : 'folder_open'"
                      :label="
                        file ? 'Arquivo Selecionado' : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInput.click()"
                    />
                    <input
                      ref="fileInput"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="onFileSelected"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="file">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info">
                    Tamanho: {{ formatFileSize(file.size) }}
                  </q-chip>
                  <q-chip color="positive" text-color="white" icon="event">
                    Tipo: {{ file.type || "Excel" }}
                  </q-chip>
                </div>
              </div>
            </div>

            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Template"
                no-caps
                icon="send"
                size="md"
                :disable="!file"
                @click="enviarTemplate"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== TAB ASSOCIAR PERFIL ===== -->
      <q-tab-panel name="associar">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Associar Perfil ao Usuário
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlideAssociar = !activeSlideAssociar"
            />
          </p>
        </div>

        <infot-upload
          :activeSlide="activeSlideAssociar"
          :infos="infosAssociar"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/controle-funcao/template-associar-perfil-usuario.xlsx"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de associação de perfil
            </h6>
          </div>

          <div class="upload-content">
            <div
              class="upload-area"
              :class="{
                'file-selected': fileAssociar,
                'drag-over': isDragOverAssociar,
              }"
              @dragover.prevent="onDragOverAssociar"
              @dragleave.prevent="onDragLeaveAssociar"
              @drop.prevent="onDropAssociar"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!fileAssociar">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />
                    {{ fileAssociar.name }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="fileAssociar ? 'positive' : 'primary'"
                      :icon="fileAssociar ? 'check_circle' : 'folder_open'"
                      :label="
                        fileAssociar
                          ? 'Arquivo Selecionado'
                          : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInputAssociar.click()"
                    />
                    <input
                      ref="fileInputAssociar"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="onFileSelectedAssociar"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="fileAssociar">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info">
                    Tamanho: {{ formatFileSize(fileAssociar.size) }}
                  </q-chip>
                  <q-chip color="positive" text-color="white" icon="event">
                    Tipo: {{ fileAssociar.type || "Excel" }}
                  </q-chip>
                </div>
              </div>
            </div>

            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Template"
                no-caps
                icon="send"
                size="md"
                :disable="!fileAssociar"
                @click="enviarAssociarPerfil"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <!-- ===== TAB DESASSOCIAR PERFIL ===== -->
      <q-tab-panel name="desassociar">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Desassociar Perfil do Usuário
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlideDesassociar = !activeSlideDesassociar"
            />
          </p>
        </div>

        <infot-upload
          :activeSlide="activeSlideDesassociar"
          :infos="infosDesassociar"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/controle-funcao/template-desassociar-perfil-usuario.xlsx"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md q-mb-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="upload-section">
          <div class="upload-header">
            <q-icon name="upload_file" size="24px" class="header-icon" />
            <h6 class="upload-title">
              Enviar planilha de desassociação de perfil
            </h6>
          </div>

          <div class="upload-content">
            <div
              class="upload-area"
              :class="{
                'file-selected': fileDesassociar,
                'drag-over': isDragOverDesassociar,
              }"
              @dragover.prevent="onDragOverDesassociar"
              @dragleave.prevent="onDragLeaveDesassociar"
              @drop.prevent="onDropDesassociar"
            >
              <div class="upload-zone">
                <div class="upload-icon-container">
                  <q-icon name="cloud_upload" size="48px" class="upload-icon" />
                </div>
                <div class="upload-text-container">
                  <p class="upload-main-text" v-if="!fileDesassociar">
                    Arraste e solte sua planilha aqui ou
                  </p>
                  <p class="upload-main-text selected" v-else>
                    <q-icon name="description" class="q-mr-xs" />
                    {{ fileDesassociar.name }}
                  </p>
                  <div class="upload-button">
                    <q-btn
                      :color="fileDesassociar ? 'positive' : 'primary'"
                      :icon="fileDesassociar ? 'check_circle' : 'folder_open'"
                      :label="
                        fileDesassociar
                          ? 'Arquivo Selecionado'
                          : 'Selecionar Arquivo'
                      "
                      no-caps
                      rounded
                      class="upload-btn"
                      @click="fileInputDesassociar.click()"
                    />
                    <input
                      ref="fileInputDesassociar"
                      type="file"
                      accept=".xlsx,.xls"
                      @change="onFileSelectedDesassociar"
                      style="display: none"
                    />
                  </div>
                </div>
              </div>
              <div class="file-info" v-if="fileDesassociar">
                <div class="file-details">
                  <q-chip color="primary" text-color="white" icon="info">
                    Tamanho: {{ formatFileSize(fileDesassociar.size) }}
                  </q-chip>
                  <q-chip color="positive" text-color="white" icon="event">
                    Tipo: {{ fileDesassociar.type || "Excel" }}
                  </q-chip>
                </div>
              </div>
            </div>

            <div class="upload-actions">
              <q-btn
                color="positive"
                label="Enviar Planilha"
                no-caps
                icon="send"
                size="md"
                :disable="!fileDesassociar"
                @click="enviarDesassociarPerfil"
                class="send-button"
              />
            </div>
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: { InfotUpload, ListaUnidadesSelect, PageHeader },
  setup() {
    const activeSlide = ref(false);
    const activeSlideAssociar = ref(false);
    const activeSlideDesassociar = ref(false);
    const quasar = useQuasar();
    const store = useStore();
    const file = ref(null);
    const fileAssociar = ref(null);
    const fileDesassociar = ref(null);
    const fileInput = ref(null);
    const fileInputAssociar = ref(null);
    const fileInputDesassociar = ref(null);
    const isDragOver = ref(false);
    const isDragOverAssociar = ref(false);
    const isDragOverDesassociar = ref(false);

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const notifyInvalidFile = () => {
      quasar.notify({
        message: "Por favor, selecione apenas arquivos .xlsx",
        color: "negative",
        icon: "warning",
      });
    };

    // --- Tab Usuário ---
    const onFileSelected = (e) => {
      if (e.target.files[0]) file.value = e.target.files[0];
    };
    const onDragOver = () => {
      isDragOver.value = true;
    };
    const onDragLeave = () => {
      isDragOver.value = false;
    };
    const onDrop = (e) => {
      isDragOver.value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        file.value = f;
      } else {
        notifyInvalidFile();
      }
    };

    // --- Tab Associar ---
    const onFileSelectedAssociar = (e) => {
      if (e.target.files[0]) fileAssociar.value = e.target.files[0];
    };
    const onDragOverAssociar = () => {
      isDragOverAssociar.value = true;
    };
    const onDragLeaveAssociar = () => {
      isDragOverAssociar.value = false;
    };
    const onDropAssociar = (e) => {
      isDragOverAssociar.value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        fileAssociar.value = f;
      } else {
        notifyInvalidFile();
      }
    };

    // --- Tab Desassociar ---
    const onFileSelectedDesassociar = (e) => {
      if (e.target.files[0]) fileDesassociar.value = e.target.files[0];
    };
    const onDragOverDesassociar = () => {
      isDragOverDesassociar.value = true;
    };
    const onDragLeaveDesassociar = () => {
      isDragOverDesassociar.value = false;
    };
    const onDropDesassociar = (e) => {
      isDragOverDesassociar.value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        fileDesassociar.value = f;
      } else {
        notifyInvalidFile();
      }
    };

    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais",
        icon: "delete",
      },
      {
        name: "O EMAIL não é atualizado por planilha, ele é somente criado em uma primeira execução",
        icon: "view_column",
      },
      {
        name: "O CENTRO DE CUSTO não é atualizado por esta planilha, ele é somente criado em uma primeira execução.",
        icon: "do_not_disturb",
      },
      {
        name: "Se houver erro de digitação da coluna B (ID ou username) outro usuário será criado, por exemplo, se for informado inicialmente o ID 1234 e posteriormente o ID 01234, o sistema criará outro usuário",
        icon: "event",
      },
      {
        name: "Se houver erro de digitação na coluna G (código centro de custo), o sistema criará um novo centro de custo e associará ao colaborador",
        icon: "event",
      },
      {
        name: "Se houver erro de digitação na coluna F (função ou ghe), o sistema criará outra função e associará ao colaborador",
        icon: "event",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "event",
      },
    ]);

    const infosAssociar = ref([
      {
        name: "O limite para vínculo é de 50 linhas por vez",
        icon: "format_list_numbered",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais",
        icon: "delete",
      },
      {
        name: "Essa planilha não cria usuários nem perfis, só realiza o vínculo",
        icon: "link",
      },
      {
        name: "Os dois campos do template são obrigatórios (matricula_usuario e nome_perfil)",
        icon: "check_circle",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosDesassociar = ref([
      {
        name: "O limite para vínculo é de 50 linhas por vez",
        icon: "format_list_numbered",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais",
        icon: "delete",
      },
      {
        name: "Essa planilha não cria usuários nem perfis, só realiza o vínculo",
        icon: "link",
      },
      {
        name: "O campo matricula_usuario é obrigatório",
        icon: "check_circle",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const enviarTemplate = async () => {
      if (!file.value || !file.value.name.endsWith(".xlsx")) {
        notifyInvalidFile();
        return;
      }

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("user/criarUsuarioTemplate", {
          planilha: result,
          vendor: store.state.org.unidadeData.id,
        });

        quasar.notify({
          message: "Usuário criado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        file.value = null;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar Usuário",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        file.value = null;
      }
    };

    const enviarAssociarPerfil = async () => {
      if (!fileAssociar.value || !fileAssociar.value.name.endsWith(".xlsx")) {
        notifyInvalidFile();
        return;
      }

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileAssociar.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("user/associarPerfilUsuarioPlanilha", {
          planilha: result,
          vendor: store.state.org.unidadeData.id,
        });

        quasar.notify({
          message: "Planilha enviada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        fileAssociar.value = null;
      } catch (error) {
        console.log(error);
        const mensagem =
          error?.response?.data?.message ||
          "Erro ao enviar planilha de associação de perfil";
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        fileAssociar.value = null;
      }
    };

    const enviarDesassociarPerfil = async () => {
      if (
        !fileDesassociar.value ||
        !fileDesassociar.value.name.endsWith(".xlsx")
      ) {
        notifyInvalidFile();
        return;
      }

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileDesassociar.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("user/desassociarPerfilUsuarioPlanilha", {
          planilha: result,
          vendor: store.state.org.unidadeData.id,
        });

        quasar.notify({
          message: "Planilha enviada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        fileDesassociar.value = null;
      } catch (error) {
        console.log(error);
        const mensagem =
          error?.response?.data?.message ||
          "Erro ao enviar planilha de desassociação de perfil";
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        fileDesassociar.value = null;
      }
    };

    return {
      enviarTemplate,
      enviarAssociarPerfil,
      enviarDesassociarPerfil,
      file,
      fileAssociar,
      fileDesassociar,
      fileInput,
      fileInputAssociar,
      fileInputDesassociar,
      isDragOver,
      isDragOverAssociar,
      isDragOverDesassociar,
      onFileSelected,
      onDragOver,
      onDragLeave,
      onDrop,
      onFileSelectedAssociar,
      onDragOverAssociar,
      onDragLeaveAssociar,
      onDropAssociar,
      onFileSelectedDesassociar,
      onDragOverDesassociar,
      onDragLeaveDesassociar,
      onDropDesassociar,
      formatFileSize,
      activeSlide,
      activeSlideAssociar,
      activeSlideDesassociar,
      infos,
      infosAssociar,
      infosDesassociar,
      tab: ref("usuario"),
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}

.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}

.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}

.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
